module.exports = __webpack_public_path__ + "img/home-btn-openeye.a43ab4eb.svg";